module.exports = __webpack_public_path__ + "img/volvo_upOkImg.4ad7be1c.svg";